import React from 'react';
import { view } from 'react-easy-state';
import { withTranslation } from 'react-i18next';

const PrestSceltaStruttura = ({ prestazione, t }) => {
  return (
    <div className="kfpr-row kfpr-row-small">
        <span>{t("Struttura")}</span>
        <strong>{prestazione.get('struttura')}</strong>
    </div>
  )
}

export default withTranslation()(view(PrestSceltaStruttura));
